import Vue from 'vue';
import Router from 'vue-router';

import Login from './views/Login';
import Main from './views/Layout';
import Homepage from './views/Homepage';

import PracticeList from './views/Practice/PracticeList';
import PracticeSharedList from './views/Practice/PracticeSharedList';
import PracticeView from './views/Practice/PracticeView';
import PracticeCreator from './views/Practice/PracticeCreator';
import PracticeUpdate from './views/Practice/PracticeUpdate';

import Calendar from './views/Calendar';
import ConspectList from './views/Conspect/ConspectList';
import ConspectSharedList from './views/Conspect/ConspectSharedList';
import ConspectUpdate from './views/Conspect/ConspectUpdate';
import ConspectCreator from './views/Conspect/ConspectCreator';
import Notifications from './views/Notifications/Notifications';
import MyProfile from './views/SettingsTab/MyProfile';
import MyFriends from './views/SettingsTab/MyFriends';

Vue.use(Router);

const router = new Router({
    routes: [
        {
            path: '/',
            component: Main,
            children: [
                {
                    path: '',
                    component: Homepage
                },
                {
                    path: 'createAnimation',
                    component: PracticeCreator
                },
                {
                    path: 'editAnimation/:id',
                    component: PracticeUpdate
                },
                {
                    path: 'editConspect/:id',
                    component: ConspectUpdate
                },
                {
                    path: 'viewAnimation/:id',
                    component: PracticeView
                },
                {
                    path: 'createConspect',
                    component: ConspectCreator
                },
                {
                    path: 'conspect-list',
                    component: ConspectList
                },
                {
                    path: 'practice',
                    component: PracticeList
                },
                {
                    path: 'sharedPractice',
                    component: PracticeSharedList
                },
                {
                    path: 'sharedConspect',
                    component: ConspectSharedList
                },
                {
                    path: 'calendar',
                    component: Calendar
                },
                {
                    path: 'notifications',
                    component: Notifications
                },
                {
                    path: 'profile',
                    component: MyProfile
                },
                {
                    path: 'friends',
                    component: MyFriends
                }
            ]
        },
        {
            path: '/login',
            component: Login,
            meta: { noRequireAuthorization: true }
        }
    ]
});

router.beforeEach((to, from, next) => {

    if (to.matched.some(record => record.meta.noRequireAuthorization)) {
        next();
    } else {
        if (to.path !== '/login') {
            AuthMiddleware.checkIsUserLogged()
                .then((returned)=>{
                    if(returned){
                        next();
                        setTimeout(()=>{
                            if(window.jsFrameworkAfterChangeRoute) window.jsFrameworkAfterChangeRoute();
                        },300);
                    }else{
                        next({
                            path: '/login',
                            query: {
                                redirect: to.fullPath ? to.fullPath : null,
                            }
                        });
                    }
                })
                .catch(()=>{
                    next({
                        path: '/login',
                        query: {
                            redirect: to.fullPath ? to.fullPath : null,
                        }
                    });
                });
        } else {
            next();
        }
    }
});

export default router;